export default function NotFoundPage() {
    return <div className="NotFoundPage">
        <h1>Oops!</h1>
        <p>404 - Page not found.</p>
    </div>;
}